<template>
    <div :class="['ObjectPreview', {'ObjectPreview--liked': likeStatus === 1}]">
        <div class="ObjectPreview__id">ID {{id}}</div>
        <div class="ObjectPreview__image" :style="{'background-image': `url('${images[0]}')`}">
            <router-link :to="{name: 'object', params: {id}}">
                <EyeIcon/>
            </router-link>
        </div>
        <div class="ObjectPreview__body">
            <div class="ObjectPreview__params">
                <ObjectParams :params="objectSlice(params, 4)"/>
            </div>
            <div class="ObjectPreview__main">
                <div class="ObjectPreview__price">
                    <ObjectPrice v-bind="price"/>
                </div>
                <div class="ObjectPreview__like-buttons">
                    <ObjectLikeButtonsCompact :status="likeStatus" :id="id"/>
                </div>
                <ObjectMoreInfoLink :id="id"/>
            </div>
        </div>
    </div>
</template>

<script>
import ObjectPrice from "@/components/Object/ObjectPrice";
import ObjectMoreInfoLink from "@/components/Object/ObjectMoreInfoLink";
import ObjectLikeButtonsCompact from "@/components/Object/ObjectLikeButtonsCompact";
import ObjectParams from "@/components/Object/ObjectParams";
import EyeIcon from "@/assets/image/icons/eye.svg?inline";
import {objectSlice} from "@/utils/objectSlice";

export default {
    name: "ObjectPreview",
    inheritAttrs: false,
    components: {
        ObjectPrice,
        ObjectMoreInfoLink,
        ObjectLikeButtonsCompact,
        ObjectParams,
        EyeIcon,
    },
    props: {
        id: [Number, String],
        price: {
            current: [Number, String],
            prev: [Number, String]
        },
        params: Object,
        likeStatus: Number,
        images: Array,
    },
    methods: {
        objectSlice,
    }
}
</script>

<style lang="scss">
.ObjectPreview {
  position: relative;
  height: 94px;
  display: flex;
  background-color: $white;
  border-radius: 8px;

  &--liked {
    border: solid 2px $secondary;
  }

  @include tablet {
    min-height: 130px;
  }

  @include mobile {
    min-height: 160px;
  }

  &__id {
    font-size: 12px;
    width: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    writing-mode: vertical-lr;
    transform: rotate(180deg);

    @include tablet {
      width: 34px;
    }
  }

  &__image-wrapper {
    height: 100%;
  }

  &__image {
    position: relative;
    width: 110px;
    height: 100%;
    background-position: center;
    background-size: cover;
    background-color: $grayLight;
    border-radius: 8px;

    @include svgFill($white);

    a {
      height: 100%;
      width: 100%;

      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  &__body {
    width: 100%;
    padding: 12px 16px 12px 24px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    @include tablet {
      align-items: flex-start;
      flex-direction: column;
    }
  }

  &__params {
    height: 100%;
    display: flex;
    align-items: center;
    padding-right: 52px;

    @include tablet {
      margin-bottom: 8px;
    }

    @include mobile {
      padding-right: 0;
    }

    .ObjectParams {
      display: grid;
      grid-template-columns: auto auto;
      grid-gap: 12px 16px;

      &__item {
        margin-top: 0 !important;
      }
    }
  }

  &__main {
    display: flex;
    align-items: center;

    @include tablet {
      width: 100%;
      justify-content: space-between;
    }

    @include mobile {
      flex-wrap: wrap;
    }
  }

  &__price {
    margin-right: 32px;

    @include tablet {
      order: 3;
      margin-right: 0;
    }
  }

  &__like-buttons {
    margin-right: 32px;

    @include tablet {
      position: absolute;
      top: 18px;
      right: 20px;
      margin-right: 0;
    }

    @include mobile {
      position: static;
      top: auto;
      right: auto;
    }
  }
}
</style>
